import { openDB } from 'idb';

const DB_NAME = 'uploadDB';
const DB_STORE_NAME = 'files';
export const hasLocalStorage = () => {
  return typeof Storage !== 'undefined' && typeof localStorage === 'object';
};

export const setLocalStorage = (key: string, value: string) => {
  if (hasLocalStorage()) {
    localStorage.setItem(key, value);
  }
};

export const getLocalStorage = (key: string) => {
  if (hasLocalStorage()) {
    return localStorage.getItem(key);
  }
};

export const removeLocalStorage = (key: string) => {
  if (hasLocalStorage()) {
    localStorage.removeItem(key);
  }
};

export const hasSessionStorage = () => {
  return typeof Storage !== 'undefined' && typeof sessionStorage === 'object';
};

export const setSessionStorage = (key: string, value: string) => {
  if (hasSessionStorage()) {
    sessionStorage.setItem(key, value);
  }
};

export const getSessionStorage = (key: string) => {
  if (hasSessionStorage()) {
    return sessionStorage.getItem(key);
  }
};

export const removeSessionStorage = (key: string) => {
  if (hasSessionStorage()) {
    sessionStorage.removeItem(key);
  }
};

export const getCookie = (key: string, cookie?: string) => {
  const searchCookie = cookie ?? document.cookie;

  return (
    decodeURIComponent(
      searchCookie.replace(
        new RegExp(
          '(?:(?:^|.*;)\\s*' +
            encodeURIComponent(key).replace(/[-.+*]/g, '\\$&') +
            '\\s*\\=\\s*([^;]*).*$)|^.*$',
        ),
        '$1',
      ),
    ) || ''
  );
};

export const setCookie = (name: string, value: string, days?: number) => {
  const date = new Date();
  date.setTime(
    date.getTime() +
      1000 * 60 * 60 * 24 * (typeof days === 'number' ? days : 14),
  );
  const expires = 'expires=' + date.toUTCString();
  document.cookie =
    `${name}=${value}; ${expires}; path=/` + expires + ';path=/';
};

export const removeCookie = (name: string) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
};

/**
 * 初始化数据库
 */
async function initDB() {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(DB_STORE_NAME)) {
        db.createObjectStore(DB_STORE_NAME);
      }
    },
  });
}
export async function saveDBFile(key: string, file: any) {
  const db = await initDB();
  await db.put(DB_STORE_NAME, file, key);
}

export async function getDBFile(key: string) {
  const db = await initDB();
  const file = await db.get(DB_STORE_NAME, key);
  return file || null;
}

export async function deleteDBFile(key: string) {
  const db = await initDB();
  await db.delete(DB_STORE_NAME, key);
}

export async function clearAllDBFiles() {
  const db = await initDB();
  await db.clear(DB_STORE_NAME);
}
